import { ApiReferenceReact } from '@scalar/api-reference-react';
import '@scalar/api-reference-react/style.css';

export function DocsPage() {
  return (
    <div className="docs-frame">
      <ApiReferenceReact
        configuration={{
          url: '/api/spec',
          title: 'My Cloud Cinema API',
          darkMode: true,
        }}
      />
    </div>
  );
}
